// extracted by mini-css-extract-plugin
module.exports = {"modal":"AccidentForm_modal__OyBCH","tableCell":"AccidentForm_tableCell__2btCm","tableTitleCell":"AccidentForm_tableTitleCell__PTRIb","steps":"AccidentForm_steps__ZozAn"};